import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            多维分类检索
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            通过类型、演员、厂牌、系列等多种维度，快速定位你想要的番号信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-xl mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-4">{cat.description}</p>
              <div className="flex flex-wrap gap-1.5">
                {cat.subCategories.slice(0, 4).map((sub) => (
                  <span
                    key={sub.slug}
                    className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium"
                  >
                    {sub.name}
                  </span>
                ))}
                {cat.subCategories.length > 4 && (
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-200 text-foreground-500 text-xs">
                    +{cat.subCategories.length - 4}
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}